/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-07-18 12:25:48
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-07-29 14:33:45
 */
const producer = () => import("@/views/operators/producer/producer.vue");
const producerAdd = () => import("@/views/operators/producer/children/add.vue");
const producerUpd = () => import("@/views/operators/producer/children/updata.vue");
// const merchantManagement = () =>
//   import("@/views/operators/merchant-management/merchant-management.vue");
// const editMerchant = () =>
//   import("@/views/operators/merchant-management/children/edit-merchant.vue");
// const detailMerchant = () =>
//   import("@/views/operators/merchant-management/children/details-merchant.vue");
// const addMerchant = () =>
//   import("@/views/operators/merchant-management/children/add-merchant.vue");
// const editAccount = () =>
//   import("@/views/operators/merchant-management/children/edit-account.vue");
// const editLoginInfo = () =>
//   import("@/views/operators/merchant-management/children/edit-login-info.vue");
// const resetPassword = () =>
//   import("@/views/operators/merchant-management/children/reset-password.vue");
const homeInfo = () => import("@/views/operators/home-info/home-info.vue");
// const homeInfoUpPsaaword = () =>
//   import("@/views/operators/home-info/children/up-password/up-password.vue");
// const homeInfoUpMailbox = () =>
//   import("@/views/operators/home-info/children/up-mailbox/up-mailbox.vue");
// const homeInfoUpPhone = () =>
//   import("@/views/operators/home-info/children/up-phone/up-phone.vue");
const homeInfoUpLogo = () => import("@/views/operators/home-info/children/up-logo/up-logo.vue");
const homeUpOperInfo = () => import("@/views/operators/home-info/children/up-oper-info/up-oper-info.vue");
const upChargeConfig = () => import("@/views/operators/home-info/children/up-charge-config/up-charge-config.vue");
const homeInfoSOC = () => import("@/views/operators/home-info/children/up-SOC/up-SOC.vue");
const homeInfoSafePassword = () => import("@/views/operators/home-info/children/up-safe-password/up-safe-password.vue");
const homeUpSettlementConfig = () => import("@/views/operators/home-info/children/up-settlement-config/up-settlement-config.vue");
const upBalanceConfig = () => import("@/views/operators/home-info/children/up-balance-config/up-balance-config.vue");
const equipmentModel = () => import("@/views/operators/equipment-model/equipment-model.vue");
const equipmentModelAdd = () => import("@/views/operators/equipment-model/children/equipment-model-add/equipment-model-add.vue");
const equipmentModelUpdate = () => import("@/views/operators/equipment-model/children/equipment-model-updata.vue");
const equipmentModelDetail = () => import("@/views/operators/equipment-model/children/equipment-model-details.vue");
const routerList = [
    {
        path: "/operators/producer",
        name: "设备生产商信息",
        component: producer,
        children: [
            {
                path: "/operators/producer/add",
                name: "新增设备生产商信息",
                component: producerAdd,
                meta: {
                    nameKey: "producerAdd",
                },
            },
            {
                path: "/operators/producer/Upd",
                name: "编辑设备生产商信息",
                component: producerUpd,
                meta: {
                    nameKey: "producerUp",
                },
            },
        ],
    },
    // {
    //   path: "/operators/merchant-management",
    //   name: "商户管理",
    //   component: merchantManagement,
    // },
    // {
    //   path: "/operators/merchant-management/edit-merchant",
    //   name: "编辑商户",
    //   component: () =>
    //     import(
    //       "@/views/operators/merchant-management/children/edit-merchant/edit-merchant.vue"
    //     ),
    //   meta: {
    //     nameKey: "merchantUp",
    //   },
    // },
    // {
    //   path: "/operators/merchant-management/add-merchant",
    //   name: "新增商户",
    //   // component: addMerchant,
    //   component: () =>
    //     import(
    //       "@/views/operators/merchant-management/children/add-merchant/add-merchant.vue"
    //     ),
    //   meta: {
    //     nameKey: "merchantAdd",
    //   },
    // },
    // {
    //   path: "/operators/merchant-management/merchant-detail",
    //   name: "商户详情",
    //   component: () =>
    //     import(
    //       "@/views/operators/merchant-management/children/details-merchant/details-merchant.vue"
    //     ),
    //   meta: {
    //     nameKey: "merchantDetails",
    //   },
    // },
    // {
    //   path: "/operators/merchant-management/operation-log",
    //   name: "商户日志",
    //   component: () =>
    //     import(
    //       "@/views/operators/merchant-management/children/mch-operation-log/mch-operation-log.vue"
    //     ),
    //   meta: {
    //     nameKey: "mchOperationLog",
    //   },
    // },
    // {
    //   path: "/operators/merchant-management/edit-account",
    //   name: "编辑商户账户",
    //   component: editAccount
    // },
    // {
    //   path: "/operators/merchant-management/edit-login-info",
    //   name: "编辑登录用户名",
    //   component: editLoginInfo
    // },
    // {
    //   path: "/operators/merchant-management/reset-password",
    //   name: "重置密码",
    //   component: resetPassword
    // },
    {
        path: "/operators/oper-info",
        name: "运营商信息",
        component: homeInfo,
        children: [
            // {
            //   path: "/operators/oper-info/up-password",
            //   name: "修改密码",
            //   component: homeInfoUpPsaaword
            // },
            // {
            //   path: "/operators/oper-info/up-mailbox",
            //   name: "修改邮箱",
            //   component: homeInfoUpMailbox
            // },
            // {
            //   path: "/operators/oper-info/up-phone",
            //   name: "修改手机号码",
            //   component: homeInfoUpPhone
            // },
            {
                path: "/operators/oper-info/up-logo",
                name: "修改系统信息",
                component: homeInfoUpLogo,
                meta: {
                    nameKey: "operInfoUpSys",
                },
            },
            {
                path: "/operators/oper-info/up-oper-info",
                name: "运营商基本信息",
                component: homeUpOperInfo,
                meta: {
                    nameKey: "operInfoUp",
                },
            },
            {
                path: "/operators/oper-info/up-charge-config",
                name: "充电服务配置",
                component: upChargeConfig,
                meta: {
                    nameKey: "operInfoChargeConfig",
                },
            },
            {
                path: "/operators/oper-info/contact-service-provider",
                name: "联系服务商",
                component: () => import("@/views/operators/home-info/children/contact-service-provider/contact-service-provider.vue"),
            },
            {
                path: "/operators/oper-info/up-SOC",
                name: "SOC定制",
                component: homeInfoSOC,
                meta: {
                    nameKey: "operInfoSoc",
                },
            },
            {
                path: "/operators/oper-info/up-safe-password",
                name: "修改操作密码",
                component: homeInfoSafePassword,
                meta: {
                    nameKey: "operInfoUpSafePassword",
                },
            },
            {
                path: "/operators/oper-info/up-settlement-config",
                name: "结算配置",
                component: homeUpSettlementConfig,
                meta: {
                    nameKey: "operInfoUpSettlement",
                },
            },
            {
                path: "/operators/oper-info/up-balance-config",
                name: "余额提醒",
                component: upBalanceConfig,
                meta: {
                    nameKey: "operInfoUpBalance",
                },
            },
            {
                path: "/operators/oper-info/invoice-settings",
                name: "发票设置",
                component: () => import("@/views/operators/home-info/children/invoice-settings/invoice-settings.vue"),
                meta: {
                    nameKey: "invoiceSettings",
                },
            },
            {
                path: "/operators/oper-info/invoice-settings-paper",
                name: "发票设置",
                component: () => import("@/views/operators/home-info/children/up-settlement-config-paper/up-settlement-config-paper.vue"),
                meta: {
                    nameKey: "invoiceSettingsPaper",
                },
            },
        ],
    },
    {
        path: "/operators/equipment-model",
        name: "设备型号",
        component: equipmentModel,
        children: [
            {
                path: "/operators/equipment-model/add",
                name: "新增设备型号",
                component: equipmentModelAdd,
                meta: {
                    nameKey: "equipmentModelAdd",
                },
            },
            {
                path: "/operators/equipment-model/update",
                name: "修改设备型号",
                component: equipmentModelUpdate,
                meta: {
                    nameKey: "equipmentModelUpdate",
                },
            },
            {
                path: "/operators/equipment-model/detail",
                name: "设备型号详情",
                component: equipmentModelDetail,
                meta: {
                    nameKey: "equipmentModelDetail",
                },
            },
        ],
    },
    {
        path: "/operators/report-file",
        name: "报告档案",
        component: () => import("@/views/operators/report-file/report-file.vue"),
        children: [
            {
                path: "/operators/report-file/details",
                name: "报告档案详情",
                component: () => import("@/views/operators/report-file/children/details/details.vue"),
                meta: {
                    nameKey: "reportFileDetail",
                },
            },
        ],
    },
];
export default routerList;
